import { observer } from 'mobx-react'

import type { ChangeEvent } from 'react'

import { Select as SharedSelect } from '../../Select/Select'
import type { SelectFieldFilter } from '../../../models/common/Filters/SelectFieldFilter'

import { SvgForSelectFilterIcon, filterValueOptionAsSelectOption } from './utils'
import type { TableFilterComponentProps } from './types'


const Select: React.FC<TableFilterComponentProps<SelectFieldFilter>> = ({ fieldName, fieldFilter, onFiltersChanged }) => {
  return <SharedSelect
    name={fieldName}
    title={fieldName}
    showLabel={false}
    StartIcon={SvgForSelectFilterIcon(fieldFilter.icon)}
    options={fieldFilter.selectOptions.map(filterValueOptionAsSelectOption)}
    isFilter={true}
    style={fieldFilter.maxWidth === undefined ? undefined : { maxInlineSize: fieldFilter.maxWidth }}
    selectedOptions={
      fieldFilter.filterValue === undefined
        ? [fieldFilter.allValuesSelectOption]
        : [filterValueOptionAsSelectOption(fieldFilter.filterValue)]
    }
    onChange={({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
      fieldFilter.setFilterValue(value === fieldFilter.allValuesSelectOption.value ? undefined : value)
      onFiltersChanged?.(value)
    }}
  />
}

export default observer(Select);